// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @ utils
const { formatText } = require('core/i18n').i18n;
const includes = require('lodash/collection/includes');

const PassContainer = require('components/contactCenter/passContainer/passContainer');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { PasswordPositions } = require('components/contactCenter/passwordPositions/passwordPositions');


//@constants
const {
    ERROR_INVALID_PASSWORD,
    ERROR_USER_BLOCKED
} = require('constants/contactCenter/errorTypes');

require('./KeysCCStep3.scss');

class KeysCCStep3 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            positions: null,
            values: null,
            finishHasBeenPressed: false
        };
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleRequestLogin = this.handleRequestLogin.bind(this);
        this.passwordRecoveryCallback = this.passwordRecoveryCallback.bind(this);
        this.builFormInfo = this.builFormInfo.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.resetCounter !== nextProps.resetCounter && nextProps.resetCounter) {
            this.setState({
                positions: null,
                values: null,
                finishHasBeenPressed: false
            });
        }
    }

    handlePasswordChange(object) {
        const { positions, values } = object;
        this.setState({
            positions,
            values
        });
    }

    passwordRecoveryCallback() {
        this.props.handleResetView();
    }

    handleRequestLogin(){
        const { positions, values } =  this.state;
        this.setState(() => ({finishHasBeenPressed: true}));
        if(values && !includes(values, '')){
            this.props.handleRequestLogin(positions, values);
        }
    }

    handleCancelClick(){
        const url = '/disasterRecovery/customerFinder';
        this.props.history.push(url);
    }

    buildFooterButtons() {
        const { isFetchingLogin } = this.props;
        const textLeftButton= formatText('keysCCStep2-cancelButton');
        const textRightButton= formatText('keysCCStep2-confirmButton');

        return (
            <div className="keys-cc-step2__buttons">
                <div className="keys-cc-step2__left-button">
                    <OKButton modifier="secondary" size="small" onClick={() => this.handleCancelClick()}>{textLeftButton}</OKButton>
                </div>
                <div className="keys-cc-step2__right-button">
                    <OKButton
                        modifier="primary"
                        onClick={this.handleRequestLogin}
                        loading={isFetchingLogin}
                        >
                        {textRightButton}
                    </OKButton>
                </div>
            </div>
        );
    }

    builFormInfo() {
        const inputInfo1 = formatText('keysCCStep2-inputInfo1');
        const inputInfo2 = formatText('keysCCStep2-inputInfo2');

        return (
            <span>
                <span>{inputInfo1}</span>
                <OKButton
                    modifier="secondary"
                    size="one-character"
                    onClick={this.handleRequestNewCode}>
                    {inputInfo2}
                </OKButton>
            </span>
        )
    }

    handleOTPChange(event) {
        this.setState({
            codeOTP: event.target.value
        });
    }

    render() {
        const { titleStep , currentStep ,documentNumber , documentType , documentTypeCode , nameCustomer , isFetchingLogin, passwordErrorType} = this.props;
        const {values, finishHasBeenPressed} = this.state;
        const step = 3;
        const title = titleStep;
        const buttons = this.buildFooterButtons();
        const LabelName = formatText('recoveryKeysDisaster-labelNameStepThree');
        const labelTypeDoc = formatText('recoveryKeysDisaster-labelTypeDocStepThree');
        const labelNumberDoc = formatText('recoveryKeysDisaster-labelNumberDocStepThree');
        const disable =  currentStep == step;

        const isInvalidPassword = passwordErrorType === ERROR_INVALID_PASSWORD || ((!values || includes(values, '')) && finishHasBeenPressed);

        return (
            <PassContainer step={step} title={title} buttons={buttons} disable={!disable}>
                <div className="keys-cc-step3">
                    <div className="row">
                        <div className="col-xs-4">
                            <div className="keys-cc-step3__column">
                                <p className="keys-cc-step3__label-primary-info">{LabelName}</p>
                                <p className="keys-cc-step3__primary-info">{nameCustomer}</p>
                            </div>
                        </div>
                        <div className="col-xs-2">
                            <div className="keys-cc-step3__column">
                                <p className="keys-cc-step3__label-primary-info">{labelTypeDoc}</p>
                                <p className="keys-cc-step3__primary-info">{documentType}</p>
                            </div>
                        </div>
                        <div className="col-xs-4">
                            <div className="keys-cc-step3__column">
                                <p className="keys-cc-step3__label-primary-info">{labelNumberDoc}</p>
                                <p className="keys-cc-step3__primary-info">{documentNumber}</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="keys-cc-step3__column">
                                <PasswordPositions
                                    documentType={documentTypeCode}
                                    documentNumber={documentNumber}
                                    className="keys-cc-step3__password-positions"
                                    onInputDigit={this.handlePasswordChange}
                                    disabled={isFetchingLogin}
                                    isInvalidPasswordError={isInvalidPassword}
                                    isPasswordBlockedError={passwordErrorType === ERROR_USER_BLOCKED}
                                    passwordRecoveryCallback={this.passwordRecoveryCallback}
                                    onEnterKey={this.handleRequestLogin}
                                />
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>
            </PassContainer>
        );
    }
}

KeysCCStep3.propTypes = {
    passwordErrorType: PropTypes.string,
    titleStep: PropTypes.string.isRequired,
    nameCustomer : PropTypes.string.isRequired,
    documentNumber: PropTypes.string.isRequired,
    documentType: PropTypes.string.isRequired,
    documentTypeCode: PropTypes.string.isRequired,
    currentStep : PropTypes.number.isRequired,
    isFetchingLogin: PropTypes.bool.isRequired,
    handleRequestLogin : PropTypes.func.isRequired,
    handleResetView : PropTypes.func.isRequired,
    history : PropTypes.object.isRequired,
    resetCounter: PropTypes.number.isRequired
};

module.exports = withRouter(KeysCCStep3);
